import type { EditorRuntimeConfig } from "@lureo/editor-runtime";

// The runtime config /config.js publishes (docker/30-lureo-runtime-config.sh), read once at boot. Nothing is
// compiled in. The script publishes exactly these keys.
export const RUNTIME_CONFIG_KEYS = ["LUREO_BACKEND_URL", "LUREO_API_KEY", "LUREO_SENTRY_DSN", "LUREO_HUMANOID_CLIPS_URL"] as const;

type RuntimeConfigKey = (typeof RUNTIME_CONFIG_KEYS)[number];

export interface HostConfigWindow {
  readonly __LUREO_EDITOR_CONFIG__?: Readonly<Partial<Record<RuntimeConfigKey, string>>>;
}

export function readRuntimeConfig(win: HostConfigWindow): EditorRuntimeConfig | null {
  const config = win.__LUREO_EDITOR_CONFIG__;
  const backendUrl = config?.LUREO_BACKEND_URL?.replace(/\/+$/, "") ?? "";
  const apiKey = config?.LUREO_API_KEY ?? "";
  if (backendUrl === "" || apiKey === "") return null;
  const humanoidClipsUrl = config?.LUREO_HUMANOID_CLIPS_URL?.trim() ?? "";
  return humanoidClipsUrl === "" ? { backendUrl, apiKey } : { backendUrl, apiKey, humanoidClips: { url: humanoidClipsUrl } };
}

export const TRACE_LOGS_KEY = "lureo-editor-trace";

export function readTraceLogs(storage: Pick<Storage, "getItem"> | null | undefined): boolean {
  try {
    return storage?.getItem(TRACE_LOGS_KEY) === "1";
  } catch {
    return false;
  }
}

// Error reporting is off when there is no DSN.
export function readSentryDsn(win: HostConfigWindow): string | null {
  const dsn = win.__LUREO_EDITOR_CONFIG__?.LUREO_SENTRY_DSN?.trim() ?? "";
  return dsn === "" ? null : dsn;
}
